const s = {
  name: "CurrencyConversion2",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M11,7c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4C15,8.8,13.2,7,11,7z M9,11c0-1.1,0.9-2,2-2
			c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2C9.9,13,9,12.1,9,11z"/>
		<path class="st0" d="M0,11C0,4.9,4.9,0,11,0c6.1,0,11,4.9,11,11c0,6.1-4.9,11-11,11C4.9,22,0,17.1,0,11z M11,2c-5,0-9,4-9,9
			c0,5,4,9,9,9c5,0,9-4,9-9C20,6,16,2,11,2z"/>
		<path class="st0" d="M34.7,33.1L29,23l-5.7,10.1H34.7z M31.3,31.1h-4.6L29,27L31.3,31.1z"/>
		<path class="st0" d="M29,18c6.1,0,11,4.9,11,11c0,6.1-4.9,11-11,11c-6.1,0-11-4.9-11-11C18,22.9,22.9,18,29,18z M20,29
			c0,5,4,9,9,9c5,0,9-4,9-9c0-5-4-9-9-9C24,20,20,24,20,29z"/>
		<path class="st0" d="M24,10h6v6h-2v-4h-4V10z"/>
		<path class="st0" d="M12,24h-2v6h6v-2h-4V24z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CurrencyConversion2
};
